


















import { Vue, Component, Prop } from 'vue-property-decorator'
import FileViewer from '@/views/FileViewer.vue'
import { FileInfo, VFS, PathController } from '@/api/types'
import { PageConfig } from '@/store/modules/PageConfigs'
import * as fileIcon from '@/assets/file-icon.png'

import Loader from '@/components/Loader.vue'

interface FileInfoWithThumbnail extends FileInfo {
  Thumbnails?: string[];
}

@Component({
  components: { Loader, FileViewer }
})
export default class InfoPointFolder extends Vue {
  @Prop() files!: FileInfo[]
  @Prop() root!: FileInfo
  @Prop() vfs!: Promise<VFS>
  @Prop() xattr!: string[]
  @Prop() pageConfig!: PageConfig
  @Prop() pathController!: PathController

  private filesWithThumbnail: FileInfoWithThumbnail[] = []
  private isReady = false
  private selectedFile: FileInfo

  constructor () {
    super()
    this.selectedFile = this.files[0]
  }

  async mounted () {
    this.filesWithThumbnail = await Promise.all(this.files.map(async (f: FileInfo) => {
      const vfs = await this.vfs
      const thumbnails: string[] = []
      const path = this.pathController.resolve(f).path

      const filename = await vfs.ResolveFilename(path)
      if (f.ContentType === 'video/mp4' || f.ContentType === 'image/jpeg' || f.ContentType === 'image/png' || f.ContentType === 'application/pdf') {
        thumbnails.push(`${filename}.thumbnail`)
      } else {
        thumbnails.push(String(fileIcon))
      }

      return {
        ...f,
        Thumbnails: thumbnails
      }
    }))
    this.isReady = true
  }

  private selectFile (index: number) {
    this.selectedFile = this.files[index]
  }
}

